////////// Setup

let BASE_URL = ''
let RESPONSE_INTERCEPTOR = null

export function setup(options) {
  if (typeof options.baseUrl === 'string') {
    BASE_URL = options.baseUrl
  }

  if (typeof options.responseInterceptor === 'function') {
    RESPONSE_INTERCEPTOR = options.responseInterceptor
  }
}

////////// Query Strings

export function parseUrl(path, options = {}) {
  let url
  if (options.external_url === true || path.match(/^https?:\/\//)) {
    url = path
  } else {
    url = `${BASE_URL}/${path.replace(/^\//, '')}`
  }

  return url
}

export function createUrlQueryString(object, prefix = '') {
  if (object === null) {
    return ''
  } else if (Array.isArray(object)) {
    let keyName = `${prefix}[]`
    return object.map((aval) => createUrlQueryString(aval, keyName)).join('&')
  } else if (typeof object === 'object') {
    return Object.keys(object)
      .map((key) => {
        let keyName
        if (prefix.length > 0) {
          keyName = `${prefix}[${key}]`
        } else {
          keyName = key
        }

        let oval = object[key]

        return createUrlQueryString(oval, keyName)
      })
      .join('&')
  } else {
    let keyName = prefix
    return `${keyName}=${encodeURIComponent(object)}`
  }
}

export function decodeUrlQueryString(query) {
  if (typeof query === 'string') {
    if (query.length === 0) {
      return {}
    }

    let object = {}

    let parts = query.split('&')
    parts.forEach((part) => {
      let [key, value] = part.split('=')
      key = decodeURIComponent(key)
      value = decodeURIComponent(value)

      let keyParts = key.split('[').map(k => k.replace(']', ''))
      let partIndex = 0

      let arrayValue = false
      let valueObject = object
      while (partIndex < keyParts.length - 1) {
        let objectKey = keyParts[partIndex]
        let nextKey = keyParts[partIndex + 1]

        if (Array.isArray(valueObject)) {
          let arrayIndex = 0
          while (typeof valueObject[arrayIndex] !== 'undefined' && typeof valueObject[arrayIndex][nextKey] !== 'undefined') {
            arrayIndex += 1
          }
          valueObject[arrayIndex] = valueObject[arrayIndex] || {}
          valueObject = valueObject[arrayIndex]
          arrayValue = false
        } else {
          if (nextKey === '') {
            valueObject[objectKey] = valueObject[objectKey] || []
            arrayValue = true
          } else {
            valueObject[objectKey] = valueObject[objectKey] || {}
            arrayValue = false
          }
          valueObject = valueObject[objectKey]
        }

        partIndex += 1
      }

      let objectKey = keyParts[partIndex]
      if (arrayValue) {
        valueObject[objectKey] = valueObject[objectKey] || []
        valueObject[objectKey].push(value)
      } else {
        valueObject[objectKey] = value
      }
    })

    return object
  } else {
    let object = {}
    query.forEach((value, key) => {
      object[key] = value
    })

    return object
  }
}

////////// Request

export function sendRequest(method, path, options = {}) {
  let requestParams = [method, path, options]

  let handler = (resolve, reject) => {
    options.resolve = resolve
    options.reject = reject

    let headers = options.headers || {}
    let params = options.params || {}
    let includes = options.includes || []
    let body = options.body || null
    let files = options.files || null

    ///// Path
    let url = parseUrl(path, options)
    method = method.toUpperCase()

    ///// Params
    if (includes && includes.length > 0) {
      params.includes = includes
    }

    if (files) {
      body = new FormData()
      Object.keys(files).forEach((fileKey) => {
        body.append(fileKey, files[fileKey])
      })
    } else if (Object.keys(params).length > 0 && !body) {
      switch (method) {
        case 'POST':
        case 'PUT':
          body = JSON.stringify(params)
          headers['Content-Type'] = 'application/json; charset=utf-8'
          break
        case 'GET':
        default:
          url += `?${createUrlQueryString(params)}`
      }
    }

    ///// Headers
    headers['X-Requested-With'] = 'XMLHttpRequest'

    ///// XHR
    let xhr = new XMLHttpRequest()
    xhr.open(method, url)
    Object.keys(headers).forEach(key => {
      xhr.setRequestHeader(key, headers[key])
    })

    ///// Callbacks
    let handleResponse = function() {
      let response = new Response(xhr)

      let interceptorCancelled = false
      if (RESPONSE_INTERCEPTOR) {
        let interceptOptions = RESPONSE_INTERCEPTOR(response, requestParams) || {}

        if (interceptOptions.cancel) {
          interceptorCancelled = true
        }
      }

      if (window.CustomEvent) {
        let event = new CustomEvent('jsapi:requestend', {
          cancelable: true,
          detail: [response, requestParams]
        })
        let eventCancelled = !document.dispatchEvent(event)

        if (interceptorCancelled || eventCancelled) { return }
      } else {
        if (interceptorCancelled) { return }
      }

      resolve(response)
    }

    xhr.onload = handleResponse
    xhr.onerror = handleResponse

    if (body) {
      xhr.send(body)
    } else {
      xhr.send()
    }
  }

  return new Promise(handler)
}

////////// Response

export class Response {
  constructor(xhr) {
    this._xhr = xhr

    this.status = xhr.status
    this.contentType = xhr.getResponseHeader('Content-Type')
    this.success = (xhr.status >= 200 && xhr.status < 300)
    this.url = xhr.responseURL

    if (this.contentType && this.contentType.indexOf(';') !== -1) {
      this.contentType = this.contentType.split(';')[0]
    }

    this.processContent()
  }

  processContent() {
    switch (this.contentType) {
      case 'application/json':
        this.content = JSON.parse(this._xhr.responseText)
        break
      case 'text/html': {
        let html = document.createElement('html')
        html.innerHTML = this._xhr.responseText

        this.content = html
        break
      }
      default:
        this.content = this._xhr.responseText
        break
    }
  }
}
